// ── Client-side event logger ──────────────────────────────────────────────────
// Fire-and-forget. Never throws, never blocks the UI.
import { getUser } from './auth';

const API_BASE = import.meta.env.VITE_API_URL || 'https://masterfileai-api.azurewebsites.net';

// One session ID per browser tab
const SESSION_ID = Math.random().toString(36).slice(2, 11);

export function logEvent(event_type, metadata = {}) {
  try {
    const user = getUser();
    const payload = {
      tenant_id:     user?.tenant_id  || null,
      user_id:       user?.user_id    || null,
      session_id:    SESSION_ID,
      event_type,
      page:          window.location.pathname,
      metadata:      Object.keys(metadata).length ? metadata : null,
      error_message: metadata?.error || metadata?.error_message || null,
    };
    fetch(`${API_BASE}/api/events`, {
      method:  'POST',
      headers: { 'Content-Type': 'text/plain' },
      body:    JSON.stringify(payload),
    }).catch(() => {}); // truly fire-and-forget
  } catch (_) {}
}

// Shorthand helpers
export const logPage    = (page, meta)  => logEvent('page_view',  { page, ...meta });
export const logError   = (source, err) => logEvent('api_error',  { source, error: String(err?.message || err) });
export const logUpload  = (type, meta)  => logEvent(`upload_${type}`, meta);
export const logAction  = (type, meta)  => logEvent(type, meta);
